const NotificationAlertStatusCode = (props) => {
  const { statusCode, setOpenSIA, setOpenSIPA } = props;

  const STATUS_MSG_ARR = [
    {
      id: 1,
      message:
        "  Akun anda masih menunggu verifikasi, Anda tidak bisa menggunakan fitur purchase sampai akun anda di verifikasi",
      hasButton: false,
    },
    {
      id: 2,
      message:
        " Pengajuan akun Anda ditolak. Silahkan cek alasan ditolak di Detail Informasi Akun",
      hasButton: true,
      buttonText: "Detail Informasi Akun",
    },
    {
      id: 4,
      message: "Akun ini tidak bisa melakukan purchase",
      hasButton: false,
    },
    {
      id: 6,
      message: "SIA Anda sudah kedaluwarsa, harap perbarui SIA Anda",
      hasButton: true,
      buttonText: "Perbarui SIA",
    },
    {
      id: 7,
      message: "SIPA Anda sudah kedaluwarsa, harap perbarui SIPA Anda",
      hasButton: true,
      buttonText: "Perbarui SIPA",
    },
    {
      id: 8,
      message:
        "Akun OLIN Anda sedang tangguhkan oleh MPI yang berati Anda tidak dapat mengakses fitur pembelian",
      hasButton: false,
    },
    {
      id: 9,
      message:
        "Akun OLIN Anda sedang tangguhkan oleh MPI yang berati Anda tidak dapat mengakses fitur pembelian, harap melakukan pembayaran billing agar Anda dapat terus menggunakan aplikasi OLIN",
      hasButton: true,
      buttonText: "Lunasi Billing",
    },
    {
      id: 12,
      message: "Aktifkan SP digital disini",
      hasButton: true,
      buttonText: "Aktikan SP",
    },
  ];

  const getButtonFn = () => {
    if (statusCode === 2) {
    }
    if (statusCode === 6) setOpenSIA(true);
    if (statusCode === 7 || statusCode === 12) setOpenSIPA(true);
  };

  return (
    <>
      {statusCode && STATUS_MSG_ARR.find((item) => item.id === statusCode) ? (
        <div
          className={`md:flex justify-between py-2 px-4 rounded-lg ${
            statusCode === 12 ? "bg-yellow-100" : "bg-[#FBB7C2]"
          }`}
        >
          <p className="text-[14px] font-bold flex items-center">
            {STATUS_MSG_ARR.find((item) => item.id === statusCode)?.message}
          </p>
          {STATUS_MSG_ARR.find((item) => item.id === statusCode)?.hasButton ? (
            <button
              className="px-10 py-2 bg-[#FF8D40] rounded-lg text-white font-semibold mt-2 md:mt-0 w-full md:w-fit whitespace-nowrap"
              onClick={getButtonFn}
            >
              {
                STATUS_MSG_ARR.find((item) => item.id === statusCode)
                  ?.buttonText
              }
            </button>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default NotificationAlertStatusCode;
